import React from 'react';

export function Input(props) {
  return <input className="w-full p-2 border rounded" {...props} />;
}